import { isNil, isArray, toString } from 'lodash-es'

export type QueryParams = Record<string, number | string | number[] | string[] | undefined | null>
interface Options {
  decode?: boolean
}

/**
 * Forms a concatenated string of query parameters.
 * @param params - Object with query parameters.
 */
export const getURLSearch = <T extends QueryParams>(params: T, options?: Options): string => {
  const { decode } = options ?? {}
  const search = new URLSearchParams()

  for (const [key, value] of Object.entries(params)) {
    if (!isNil(value)) {
      search.set(key, isArray(value) ? value.map(toString).join(',') : value.toString())
    }
  }

  const searchStr = search.toString()

  return decode ? decodeURIComponent(searchStr) : searchStr
}
